const APIErrors = {
    INVALID_ACCESS_TOKEN: "INVALID_ACCESS_TOKEN"
};

export { APIErrors };
